/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import IntegrationsMparticleModel from 'cio/models/integrations/mparticle';
import MPARTICLE_EVENTS from 'cio/utils/mparticle-events';
import { ToggleDelta } from '@customerio/fly-components/addon/components/fly-grouped-checklist';
interface IntegrationsMparticleFormArgs {
  integration: IntegrationsMparticleModel;
}

export default class IntegrationsMparticleForm extends Component<IntegrationsMparticleFormArgs> {
  groups = MPARTICLE_EVENTS;

  get cannotEnableIntegration() {
    return !this.args.integration.enabled && this.args.integration.events?.length === 0;
  }

  @action
  setEnabled(value: boolean) {
    this.args.integration.set('enabled', value);
  }

  @action
  setSelectedEvents({ selectedItems }: ToggleDelta) {
    this.args.integration.set('events', selectedItems);
  }

  @action
  setResolution(value: boolean) {
    this.args.integration.set('resolution', value);
  }
}
